import { render } from "./ScheduledDrafts.vue?vue&type=template&id=2d678b7c&scoped=true"
import script from "./ScheduledDrafts.vue?vue&type=script&lang=js"
export * from "./ScheduledDrafts.vue?vue&type=script&lang=js"

import "./ScheduledDrafts.vue?vue&type=style&index=0&id=2d678b7c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d678b7c"]])

export default __exports__